
import React from 'react';

interface NoMatchingCandidatesProps {
  noResultsAfterFilter: boolean; 
  noInitialSuggestions: boolean;
}

export const NoMatchingCandidates = ({ noResultsAfterFilter, noInitialSuggestions }: NoMatchingCandidatesProps) => {
  let message = 'No matching candidates found.';
  if (noInitialSuggestions) {
    message = 'No matching candidates found for this job.';
  } else if (noResultsAfterFilter) {
    message = 'No candidates match the current filter.';
  }

  return (
    <p className="text-muted-foreground text-center py-4">
      {message}
    </p>
  );
};
